import { computed } from '@vue/composition-api'

import store from '@store'

export const useAuth = () => {
  const currentUser = computed(() => store.getters.user)

  const userRole = computed(() =>
    'Company' == currentUser.value.type ? 'Corporate Admin' : 'Employee'
  )

  const isUserRole = (role) => role === currentUser.value.role

  return {
    currentUser,
    userRole,
    isUserRole
  }
}
